export default __webpack_public_path__ + "img/pin_icons/double_door_w.svg";